<div class="manager-card">
  <div class="manager-container">
    <div class="manager-img">
      <mat-icon>person</mat-icon>
    </div>
    <div class="manager-info">
      <div class="manager-info__title">{{ title }}</div>
      <div class="manager-info__name">{{ name }}</div>
    </div>
    <div class="manager-phone-icon">
      <img width="32" height="32" src="./assets/images/manager-phone.svg" alt="" role="presentation" />
    </div>
  </div>
  <div class="manager-contacts">
    <span>{{ email }}</span>
    <span>{{ phone }}</span>
  </div>
</div>
